import { PopApplication } from "../models"
import { FirebaseError } from "@angular/fire/app"
import { Firestore, collectionSnapshots } from "@angular/fire/firestore"
import { log, toUniqueNonNullableArray } from "@nx-superprep/utils"
import { chunk } from "lodash-es"
import { catchError, merge, of, tap } from "rxjs"
import { mapToEntities } from "./map-to-entities"
import { setQuery } from "./set-query"
import { QueryOptions } from "./query-options"

export function getCollection<T extends { id?: string | undefined} >(
  firestore: Firestore,
  collectionPath: string,
  options: QueryOptions,
  application: PopApplication
) {
  const names = toUniqueNonNullableArray(options?.names)
  const qs = (names.length < 30
    ? [setQuery(firestore, collectionPath, options, application)]
    : chunk(names, 30).map(c => setQuery(firestore, collectionPath, { ...options, names: c }, application))
  )
    .map(q => collectionSnapshots(q))
  return merge(...qs)
    .pipe(
      catchError((val: FirebaseError) => { log.debug(val.stack, collectionPath, options); return of() }),
      mapToEntities<T>(),
      tap(items => { if (options.cache) { items.forEach(item => { if (item.id) { options.cache?.set(item.id, item)}  })}  })
    )
}
